// @flow
import { INITIAL_DATA as RADIO_INFORMATION_INITIAL_DATA } from '../../statsradio/modules/radioConfiguration/domain/RadioInformationForm';
import { INITIAL_DATA as PLAYER_CONFIGURATION_INITIAL_DATA } from '../../statsradio/modules/radioConfiguration/domain/PlayerConfiguration';
import { INITIAL_DATA as STREAM_CONFIGURATION_INITIAL_DATA } from '../../statsradio/modules/radioConfiguration/domain/StreamConfiguration';

export type RadioConfigurationStepName = 'INITIAL' | 'FORM' | 'STREAM' | 'PLAYER' | 'DONE';

type RadioConfigurationStepData = {
  name: RadioConfigurationStepName,
  data: Object,
}

export default class RadioConfigurationStep {
  name: RadioConfigurationStepName;
  data: Object;

  constructor({ name, data }: RadioConfigurationStepData) {
    this.name = name;
    this.data = data;
  }

  getStepIndex(): number {
    switch (this.name) {
      case 'FORM':
        return 0;
      case 'STREAM':
        return 1;
      case 'PLAYER':
        return 2;
      default:
        return 0;
    }
  }

  static of(name: RadioConfigurationStepName, data: Object) {
    switch (name) {
      case 'FORM':
        return new RadioConfigurationStep({ name, data: { ...RADIO_INFORMATION_INITIAL_DATA, ...data } });
      case 'STREAM':
        return new RadioConfigurationStep({ name, data: { ...STREAM_CONFIGURATION_INITIAL_DATA, ...data } });
      case 'PLAYER':
        return new RadioConfigurationStep({ name, data: { ...PLAYER_CONFIGURATION_INITIAL_DATA, ...data } });
      default:
        return new RadioConfigurationStep({ name, data: {} });
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/domain/RadioConfigurationStep.js